
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScreeningProgressSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScreeningProgressSummary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"screenedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partiallyScreenedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conflictedScreenCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unscreenedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userRequiredVoteCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userVoteCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userVoteCountToday"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":210}};
    doc.loc.source = {"body":"fragment ScreeningProgressSummary on ScreeningProgressSummary {\n  screenedCount\n  partiallyScreenedCount\n  conflictedScreenCount\n  unscreenedCount\n  userRequiredVoteCount\n  userVoteCount\n  userVoteCountToday\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
